import { useChallengesUi } from '../queries/loyalty.queries';

export function useActiveChallengesBadge() {
  const { data } = useChallengesUi();
  return data?.length;
}
